import { create } from 'zustand';
import type { MeResponse } from '@produzionejb/types';

type AuthStatus = 'idle' | 'loading' | 'authenticated' | 'anonymous';

interface AuthState {
  status: AuthStatus;
  accessToken: string | null;
  user: MeResponse | null;
  setAuth: (input: { accessToken: string; user: MeResponse }) => void;
  setStatus: (status: AuthStatus) => void;
  clear: () => void;
}

export const useAuthStore = create<AuthState>((set) => ({
  status: 'idle',
  accessToken: null,
  user: null,
  setAuth: ({ accessToken, user }) =>
    set({ accessToken, user, status: 'authenticated' }),
  setStatus: (status) => set({ status }),
  clear: () => set({ accessToken: null, user: null, status: 'anonymous' }),
}));
